function ratingwinfo(num){
    if(num == 1){
        return{
            scorew:5,
            scorec:9,
            info:"",
        }
    }else if(num == 2){
        return{
            scorew:4,
            scorec:10,
            info:"",
        }
    }else if(num == 3){
        return{
            scorew:8,
            scorec:7,
            info:"",
        }
    }else if(num == 4){
        return{
            scorew:4,
            scorec:4,
            info:"",
        }
    }else if(num == 5){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 6){
        return{
            scorew:5,
            scorec:7,
            info:"",
        }
    }else if(num == 7){
        return{
            scorew:8,
            scorec:4,
            info:"",
        }
    }else if(num == 8){
        return{
            scorew:5,
            scorec:5,
            info:"",
        }
    }else if(num == 9){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 10){
        return{
            scorew:6,
            scorec:4,
            info:"",
        }
    }else if(num == 11){
        return{
            scorew:8,
            scorec:8,
            info:"",
        }
    }else if(num == 12){
        return{
            scorew:7,
            scorec:8,
            info:"",
        }
    }else if(num == 13){
        return{
            scorew:8,
            scorec:8,
            info:"",
        }
    }else if(num == 14){
        return{
            scorew:4,
            scorec:4,
            info:"",
        }
    }else if(num == 15){
        return{
            scorew:8,
            scorec:6,
            info:"",
        }
    }else if(num == 16){
        return{
            scorew:6,
            scorec:4,
            info:"",
        }
    }else if(num == 17){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 18){
        return{
            scorew:5,
            scorec:4,
            info:"",
        }
    }else if(num == 19){
        return{
            scorew:8,
            scorec:4,
            info:"",
        }
    }else if(num == 20){
        return{
            scorew:5,
            scorec:4,
            info:"",
        }
    }else if(num == 21){
        return{
            scorew:9,
            scorec:10,
            info:"",
        }
    }else if(num == 22){
        return{
            scorew:4,
            scorec:5,
            info:"",
        }
    }else if(num == 23){
        return{
            scorew:7,
            scorec:7,
            info:"",
        }
    }else if(num == 24){
        return{
            scorew:5,
            scorec:5,
            info:"",
        }
    }else if(num == 25){
        return{
            scorew:3,
            scorec:5,
            info:"",
        }
    }else if(num == 26){
        return{
            scorew:7,
            scorec:6,
            info:"",
        }
    }else if(num == 27){
        return{
            scorew:6,
            scorec:4,
            info:"",
        }
    }else if(num == 28){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 29){
        return{
            scorew:6,
            scorec:4,
            info:"",
        }
    }else if(num == 30){
        return{
            scorew:8,
            scorec:4,
            info:"",
        }
    }else if(num == 31){
        return{
            scorew:4,
            scorec:5,
            info:"",
        }
    }else if(num == 32){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 33){
        return{
            scorew:6,
            scorec:9,
            info:"",
        }
    }else if(num == 34){
        return{
            scorew:10,
            scorec:7,
            info:"",
        }
    }else if(num == 35){
        return{
            scorew:6,
            scorec:7,
            info:"",
        }
    }else if(num == 36){
        return{
            scorew:7,
            scorec:7,
            info:"",
        }
    }else if(num == 37){
        return{
            scorew:6,
            scorec:5,
            info:"",
        }
    }else if(num == 38){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 39){
        return{
            scorew:5,
            scorec:4,
            info:"",
        }
    }else if(num == 40){
        return{
            scorew:9,
            scorec:4,
            info:"",
        }
    }else if(num == 41){
        return{
            scorew:4,
            scorec:8,
            info:"",
        }
    }else if(num == 42){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 43){
        return{
            scorew:7,
            scorec:8,
            info:"",
        }
    }else if(num == 44){
        return{
            scorew:6,
            scorec:6,
            info:"",
        }
    }else if(num == 45){
        return{
            scorew:8,
            scorec:7,
            info:"",
        }
    }else if(num == 46){
        return{
            scorew:6,
            scorec:6,
            info:"",
        }
    }else if(num == 47){
        return{
            scorew:9,
            scorec:10,
            info:"",
        }
    }else if(num == 48){
        return{
            scorew:6,
            scorec:9,
            info:"",
        }
    }else if(num == 49){
        return{
            scorew:8,
            scorec:4,
            info:"",
        }
    }else if(num == 50){
        return{
            scorew:7,
            scorec:8,
            info:"",
        }
    }else if(num == 51){
        return{
            scorew:7,
            scorec:8,
            info:"",
        }
    }else if(num == 52){
        return{
            scorew:6,
            scorec:4,
            info:"",
        }
    }else if(num == 53){
        return{
            scorew:7,
            scorec:7,
            info:"",
        }
    }else if(num == 54){
        return{
            scorew:6,
            scorec:4,
            info:"",
        }
    }else if(num == 55){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 56){
        return{
            scorew:6,
            scorec:6,
            info:"",
        }
    }else if(num == 57){
        return{
            scorew:8,
            scorec:4,
            info:"",
        }
    }else if(num == 58){
        return{
            scorew:8,
            scorec:6,
            info:"",
        }
    }else if(num == 59){
        return{
            scorew:6,
            scorec:9,
            info:"",
        }
    }else if(num == 60){
        return{
            scorew:8,
            scorec:5,
            info:"",
        }
    }else if(num == 61){
        return{
            scorew:5,
            scorec:6,
            info:"",
        }
    }else if(num == 62){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 63){
        return{
            scorew:7,
            scorec:6,
            info:"",
        }
    }else if(num == 64){
        return{
            scorew:4,
            scorec:9,
            info:"",
        }
    }else if(num == 65){
        return{
            scorew:4,
            scorec:5,
            info:"",
        }
    }else if(num == 66){
        return{
            scorew:7,
            scorec:5,
            info:"",
        }
    }else if(num == 67){
        return{
            scorew:5,
            scorec:4,
            info:"",
        }
    }else if(num == 68){
        return{
            scorew:9,
            scorec:9,
            info:"",
        }
    }else if(num == 69){
        return{
            scorew:8,
            scorec:5,
            info:"",
        }
    }else if(num == 69){
        return{
            scorew:8,
            scorec:5,
            info:"",
        }
    }else if(num == 70){
        return{
            scorew:6,
            scorec:4,
            info:"",
        }
    }else if(num == 71){
        return{
            scorew:8,
            scorec:9,
            info:"",
        }
    }else if(num == 72){
        return{
            scorew:8,
            scorec:7,
            info:"",
        }
    }else if(num == 73){
        return{
            scorew:8,
            scorec:4,
            info:"",
        }
    }else if(num == 74){
        return{
            scorew:7,
            scorec:5,
            info:"",
        }
    }else if(num == 75){
        return{
            scorew:7,
            scorec:5,
            info:"",
        }
    }else if(num == 76){
        return{
            scorew:8,
            scorec:7,
            info:"",
        }
    }else if(num == 77){
        return{
            scorew:6,
            scorec:7,
            info:"",
        }
    }else if(num == 78){
        return{
            scorew:8,
            scorec:8,
            info:"",
        }
    }
}
export default ratingwinfo 